import { Component, Inject, ViewChild } from '@angular/core';
import { OvAutoService } from '@ov-suite/services';
import { getFieldMetadata, HasId } from '@ov-suite/ov-metadata';
import { PermissionType } from '@ov-suite/helpers-shared';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '@ov-suite/authguard-angular/lib/authentication/authentication.service';
import { OvGenericModuleParams } from '../ov-generic.types';
import { HierarchyListComponent } from '../../hierarchy-list/hierarchy-list.component';
import { verifyPermission } from '../ov-generic.guard';

@Component({
  selector: 'ov-suite-mobile-start-config',
  templateUrl: './ov-generic-list.component.html',
  styleUrls: ['./ov-generic-list.component.scss'],
})
export class OvGenericListComponent {
  canAdd = true;

  canDelete = true;

  canUpdate = true;

  itemToDelete = null;

  @ViewChild('table') table: HierarchyListComponent<HasId>;

  public isHierarchy = false;

  constructor(
    public readonly ovAutoService: OvAutoService,
    @Inject('ENTITY_OPTIONS') public readonly options: OvGenericModuleParams,
    private readonly modalService: NgbModal,
    private readonly authenticationService: AuthenticationService,
  ) {
    const metadata = getFieldMetadata(options.entity);
    const hierarchyMarkers = [];

    if (options.permissionId) {
      const permissionValue = this.getPermissionValue(options.permissionId);
      this.canAdd = verifyPermission(permissionValue, PermissionType.create);
      this.canDelete = verifyPermission(permissionValue, PermissionType.delete);
      this.canUpdate = verifyPermission(permissionValue, PermissionType.update);
    }

    for (const field of metadata.fields) {
      if (field.propertyKey === 'parent' || field.propertyKey === 'children') {
        hierarchyMarkers.push(true);
      }
      if (hierarchyMarkers.length > 1) {
        this.isHierarchy = true;
        break;
      }
    }
  }

  getPermissionValue(id: number): number {
    const user = this.authenticationService.user.value;
    return user?.permissions[id] ?? null;
  }

  onChangeFilter(input: Record<string, unknown>): void {
    this.table.setFilters(input);
  }

  onDeleteItem(input: Record<string, unknown>): void {
    this.itemToDelete = input;
  }

  onRowClick(item) {
    this.options.onClick(item, this.modalService);
  }
}
